import React from 'react'
import { Card, CardImg, CardHeader, CardFooter, CustomInput } from 'reactstrap'

import CommentWhiteIcon from '../../../assets/img/icons/COMMENT_WHITE.svg'
import LikeIcon from '../../../assets/img/icons/LIKE.svg'
import LikeWhiteIcon from '../../../assets/img/icons/LIKE_WHITE.svg'
import ShareWhiteIcon from '../../../assets/img/icons/SHARE_WHITE.svg'
import FavouriteIcon from '../../../assets/img/icons/ADD TO FAV.svg'
import FavouriteWhiteIcon from '../../../assets/img/icons/ADD TO FAV_WHITE.svg'
import Loading from '../../../components/Loading/Loading'

import './PlanPreview.css'
import Icon from '../../Icons/Icon'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'

const PlanPreview = ({
    id,
    fullName,
    imageUrl,
    isLiked,
    likesCount,
    isFavourited,
    showToggle,
    isPublic,
    fullSize,
    onLiked,
    onFavourited,
    onTogglePublic,
    loading,
    onShare,
    ...props
}) => {
    const history = useHistory()

    const onImageNotLoaded = (e) => {
        const imgElement = e.target

        imgElement.classList.add('plan-preview__img--empty')
        imgElement.src = '/images/empty.png'
    }

    return (
        <Card
            className={classNames('plan-preview', {
                'plan-preview--full': fullSize,
            })}
        >
            {!fullSize && (
                <CardHeader className="plan-preview__header">
                    {fullName}
                </CardHeader>
            )}
            {loading ? (
                <Loading isImage />
            ) : (
                <CardImg
                    className="plan-preview__img"
                    top
                    width="100%"
                    src={imageUrl}
                    onClick={() => !fullSize && history.push('/plan/' + id)}
                    loading="lazy"
                    onError={onImageNotLoaded}
                />
            )}
            {showToggle && (
                <div className="plan-preview__toggle">
                    <CustomInput
                        type="switch"
                        label="نمایش به عموم"
                        checked={isPublic}
                        id={'toggle' + id}
                        name={'toggle' + id}
                        onChange={() => onTogglePublic(id, !isPublic)}
                    />
                </div>
            )}
            <CardFooter className="plan-preview__footer">
                <Icon
                    src={isLiked ? LikeIcon : LikeWhiteIcon}
                    size="lg"
                    hoverable
                    onClick={() => onLiked(id)}
                />
                {likesCount > 0 && (
                    <span className="plan-preview__like-count">
                        {likesCount}
                    </span>
                )}
                <Icon
                    src={CommentWhiteIcon}
                    size="lg"
                    hoverable
                    onClick={() => history.push('/plan/' + id)}
                />
                <Icon
                    src={ShareWhiteIcon}
                    size="lg"
                    hoverable
                    onClick={() => onShare(id)}
                />
                <Icon
                    src={isFavourited ? FavouriteIcon : FavouriteWhiteIcon}
                    size="lg"
                    className="ml-auto"
                    hoverable
                    onClick={() => onFavourited(id)}
                />
            </CardFooter>
        </Card>
    )
}

export default PlanPreview
